export var StateInterval;
(function (StateInterval) {
    StateInterval[StateInterval["None"] = 0] = "None";
    StateInterval[StateInterval["DataRange"] = 1] = "DataRange";
    StateInterval[StateInterval["Hour"] = 2] = "Hour";
    StateInterval[StateInterval["Day"] = 3] = "Day";
    StateInterval[StateInterval["Week"] = 4] = "Week";
    StateInterval[StateInterval["Month"] = 5] = "Month";
    StateInterval[StateInterval["Year"] = 6] = "Year";
    // new ones
    StateInterval[StateInterval["ThisHour"] = 7] = "ThisHour";
    StateInterval[StateInterval["ThisDay"] = 8] = "ThisDay";
    StateInterval[StateInterval["ThisWeek"] = 9] = "ThisWeek";
    StateInterval[StateInterval["ThisMonth"] = 10] = "ThisMonth";
    StateInterval[StateInterval["ThisYear"] = 11] = "ThisYear";
})(StateInterval || (StateInterval = {}));
export var DataRangeType;
(function (DataRangeType) {
    DataRangeType[DataRangeType["Day"] = 0] = "Day";
    DataRangeType[DataRangeType["Week"] = 1] = "Week";
    DataRangeType[DataRangeType["Month"] = 2] = "Month";
    DataRangeType[DataRangeType["Year"] = 3] = "Year";
    DataRangeType[DataRangeType["Hour"] = 4] = "Hour";
})(DataRangeType || (DataRangeType = {}));
export var AggregateDataType;
(function (AggregateDataType) {
    AggregateDataType["Min"] = "Min";
    AggregateDataType["Max"] = "Max";
    AggregateDataType["Avg"] = "Avg";
})(AggregateDataType || (AggregateDataType = {}));
export class AvailableState {
    constructor() {
        this._objectType = "Unknown";
        this._stateInterfaceType = "Unknown";
    }
    get StateObjectType() {
        return this._objectType;
    }
    get StateInterfaceType() {
        return this._stateInterfaceType;
    }
    get StateResponseType() {
        return this._stateInterfaceType;
    }
    set StateObjectType(value) {
        this._objectType = value;
    }
    set StateInterfaceType(value) {
        this._stateInterfaceType = value;
    }
}
export class StateDataResponse {
    constructor() {
        this.DeviceGuid = "";
        this.DeviceChannel = 0;
        this.Count = 0;
        this.IsNextPageAvailable = false;
        this.Limit = 0;
        this.Offset = 0;
        this.Data = [];
        this.AggregateDataList = [];
    }
}
export class AggregateDataEntry {
    constructor() {
        this.DataEntryIdentity = "";
        this.AggregateData = new Map();
    }
}
export class StateData {
    constructor() {
        this.Time = "";
        this.Values = null;
        this.AggregatedBy = "";
    }
}
export var LightCondition;
(function (LightCondition) {
    LightCondition[LightCondition["Unknown"] = -1] = "Unknown";
    LightCondition[LightCondition["PitchBlack"] = 0] = "PitchBlack";
    LightCondition[LightCondition["VeryDark"] = 1] = "VeryDark";
    LightCondition[LightCondition["DarkIndoors"] = 2] = "DarkIndoors";
    LightCondition[LightCondition["DimIndoors"] = 3] = "DimIndoors";
    LightCondition[LightCondition["NormalIndoors"] = 4] = "NormalIndoors";
    LightCondition[LightCondition["BrightIndoors"] = 5] = "BrightIndoors";
    LightCondition[LightCondition["DimOutdoors"] = 6] = "DimOutdoors";
    LightCondition[LightCondition["CloudyOutdoors"] = 7] = "CloudyOutdoors";
    LightCondition[LightCondition["DirectSunlight"] = 8] = "DirectSunlight";
})(LightCondition || (LightCondition = {}));
//# sourceMappingURL=StatesHistory.js.map